import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { CompanyType } from 'src/app/interfaces/company-type';
import { Jurisdiction } from 'src/app/interfaces/jurisdiction';

import { AddressForm } from './address-form';
import { ContactForm } from './contact-form';

export class ExemptVendorForm extends FormGroup<{
  id: FormControl<undefined | number>;
  ExemptVendorTypeId: FormControl<undefined | number>;
  legalName: FormControl<undefined | string>;
  dba: FormControl<null | string>;
  ein: FormControl<null | string>;
  ssn: FormControl<null | string>;
  bsn: FormControl<null | string>;
  rsn: FormControl<null | string>;
  usesSIN: FormControl<undefined | boolean>;
  website: FormControl<null | string>;
  companyType: FormControl<null | CompanyType>;
  jurisdiction: FormControl<null | Jurisdiction>;
  address1: FormControl<string | undefined>;
  address2: FormControl<string | null>;
  city: FormControl<string | undefined>;
  state: FormControl<string | undefined>;
  zip: FormControl<string | undefined>;
  country: FormControl<undefined | ('US' | 'CA')>;
  phone: FormControl<string | null>;
  phone2: FormControl<string | null>;
  fax: FormControl<string | null>;
  mailingAddress1: FormControl<string | undefined>;
  mailingAddress2: FormControl<string | null>;
  mailingCity: FormControl<string | undefined>;
  mailingState: FormControl<string | undefined>;
  mailingZip: FormControl<string | undefined>;
  isOnSite: FormControl<boolean | undefined>;
  isProfessional: FormControl<undefined | boolean>;
  isSupplier: FormControl<undefined | boolean>;
  createdAt: FormControl<undefined | Date>;
  updatedAt: FormControl<undefined | Date>;
  llcType: FormControl<null | ('C' | 'S' | 'P' | 'disregardedEntity')>;
  is1099Issued: FormControl<undefined | boolean>;
  isArchived: FormControl<undefined | boolean>;
  accountingId: FormControl<string | null>;

  Addresses: FormArray<AddressForm>;
  StreetAddress: AddressForm;
  MailingAddress: AddressForm;

  Contacts: FormArray<ContactForm>;
}> {
  constructor() {
    super({
      id: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      ExemptVendorTypeId: new FormControl<number | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      legalName: new FormControl<undefined | string>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      dba: new FormControl<null | string>(null),
      ein: new FormControl<null | string>(null),
      ssn: new FormControl<null | string>(null),
      bsn: new FormControl<null | string>(null),
      rsn: new FormControl<null | string>(null),
      usesSIN: new FormControl<undefined | boolean>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      website: new FormControl<null | string>(null),
      companyType: new FormControl<null | CompanyType>(null),
      jurisdiction: new FormControl<null | Jurisdiction>(null),
      address1: new FormControl<string | undefined>(undefined, {
        nonNullable: true
      }),
      address2: new FormControl<null | string>(null),
      city: new FormControl<string | undefined>(undefined, {
        nonNullable: true
      }),
      state: new FormControl<string | undefined>(undefined, {
        nonNullable: true
      }),
      zip: new FormControl<string | undefined>(undefined, {
        nonNullable: true
      }),
      country: new FormControl<undefined | ('US' | 'CA')>('US', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      phone: new FormControl<null | string>(null),
      phone2: new FormControl<null | string>(null),
      fax: new FormControl<null | string>(null),
      mailingAddress1: new FormControl<string | undefined>(undefined, {
        nonNullable: true
      }),
      mailingAddress2: new FormControl<null | string>(null),
      mailingCity: new FormControl<string | undefined>(undefined, {
        nonNullable: true
      }),
      mailingState: new FormControl<string | undefined>(undefined, {
        nonNullable: true
      }),
      mailingZip: new FormControl<string | undefined>(undefined, {
        nonNullable: true
      }),
      isOnSite: new FormControl<boolean | undefined>(undefined, {
        nonNullable: true
      }),
      isProfessional: new FormControl<undefined | boolean>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      isSupplier: new FormControl<undefined | boolean>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      createdAt: new FormControl<undefined | Date>(undefined, {
        nonNullable: true
      }),
      updatedAt: new FormControl<undefined | Date>(undefined, {
        nonNullable: true
      }),
      llcType: new FormControl<null | ('C' | 'S' | 'P' | 'disregardedEntity')>(
        null
      ),
      is1099Issued: new FormControl<undefined | boolean>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      isArchived: new FormControl<undefined | boolean>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      accountingId: new FormControl<string | null>(null),

      Addresses: new FormArray<AddressForm>([]),
      StreetAddress: new AddressForm(),
      MailingAddress: new AddressForm(),

      Contacts: new FormArray<ContactForm>([])
    });
  }
}
